/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import { object } from 'prop-types';
import GenericBannerMobile from './Mobile/GenericBannerMobile';
import GenericBannerDesktop from './Desktop/GenericBannerDesktop';
import DesktopMobile from '../../../helpers/DesktopMobile/DesktopMobile';
import uniqueId from '../../../helpers/contentstack/uniqueId';

export class GenericBanner extends PureComponent {
    render() {
        const { data } = this.props;
        if (data.reference?.[0].reference?.[0]) {
            const { unique_selector = '' } = data.reference?.[0] || {};
            const deviceType = data.reference?.[0]?.device;
            switch (deviceType) {
                case 'Mobile':
                    return (
                        <DesktopMobile mobile={() => (
                            <div className="genericbanner_block" uniqueId={uniqueId(unique_selector)}>
                                <GenericBannerMobile data={data} />
                            </div>
                        )}
                        />
                    );
                case 'Desktop':
                    return (
                        <DesktopMobile desktop={() => (
                            <div className="genericbanner_block" uniqueId={uniqueId(unique_selector)}>
                                <GenericBannerDesktop data={data} />
                            </div>
                        )}
                        />
                    );

                case 'Both':
                default:
                    return (
                        <div className="genericbanner_block" uniqueId={uniqueId(unique_selector)}>
                            <DesktopMobile
                                desktop={() => <GenericBannerDesktop data={data} />}
                                mobile={() => <GenericBannerMobile data={data} />}
                            />
                        </div>
                    );
            }
        }
        return <></>;
    }
}

GenericBanner.propTypes = {
    data: object.isRequired,
};

export default GenericBanner;
